import { get } from 'lodash'
import { firebase, sortByFirebaseTimestamp } from "../../firebase"

export default {
  state: {
    alerts: {},
    alertPageLimit: 20,
    lastAlert: null
  },
  getters: {
    getAlertHistory(state) {
      return Object.values(state.alerts)
        .sort(sortByFirebaseTimestamp.bind(this, 'createdAt', 'desc'))
    },
    getUnreadAlerts(state) {
      return Object.values(state.alerts)
        .filter(a => a.isRead === false)
        .sort(sortByFirebaseTimestamp.bind(this, 'createdAt', 'desc'))
    }
  },
  actions: {
    paginateAlerts({ getters, commit, state }) {

      let query = this.$db.collection('tenants')
        .doc(getters.getSessionTenant)
        .collection('alerts')
        .where('uid', '==', get(firebase.auth(), 'currentUser.uid'))
        .limit(state.alertPageLimit)
        .orderBy('createdAt', 'desc')

      if (state.lastAlert) {
        query = query.startAfter(state.lastAlert)
      }

      query.onSnapshot(snap => {
        if (snap.docs.length === state.alertPageLimit) {
          commit('SET_LAST_ALERT', snap.docs[ snap.docs.length - 1 ])
        } else {
          commit('SET_LAST_ALERT', null)
        }

        snap.docChanges().forEach(change => {
          if (change.type === 'added') {
            const source = change.doc.metadata.hasPendingWrites ? 'Local' : 'Server'

            if (source === 'Server') {
              const { id } = change.doc
              commit('ADD_ALERT', { id, ...change.doc.data() })
            }
          }

          if (change.type === 'removed') {
            // console.log('probably dont want to remove the unread alerts')
            // commit('REMOVE_ALERT', change.doc.id)
          }

          if (change.type === 'modified') {
            const { id } = change.doc
            commit('ADD_ALERT', { id, ...change.doc.data() })
          }
        })
      }, e => console.log(e))


      // if (state.lastAlert) {
      //   this.$db.collection('tenants')
      //     .doc(getters.getSessionTenant)
      //     .collection('alerts')
      //     .where('uid', '==', get(firebase.auth(), 'currentUser.uid'))
      //     .limit(state.alertPageLimit)
      //     .orderBy('createdAt', 'desc')
      //     .startAfter(state.lastAlert)
      //     .onSnapshot(snap => {
      //       if (snap.docs.length === state.alertPageLimit) {
      //         console.log('got ', snap.docs)
      //         commit('SET_LAST_ALERT', snap.docs[ snap.docs.length - 1 ])
      //       } else {
      //         commit('SET_LAST_ALERT', null)
      //       }
      //
      //       snap.docChanges().forEach(change => {
      //         console.log(change.doc.data())
      //
      //         if (change.type === 'added') {
      //           const source = change.doc.metadata.hasPendingWrites ? 'Local' : 'Server'
      //
      //           if (source === 'Server') {
      //             const { id } = change.doc
      //             commit('ADD_ALERT', { id, ...change.doc.data() })
      //           }
      //         }
      //
      //         if (change.type === 'removed') {
      //           //console.log('probably dont want to remove the unread alerts')
      //           //commit('REMOVE_ALERT', change.doc.id)
      //         }
      //
      //         if (change.type === 'modified') {
      //           const { id } = change.doc
      //           commit('ADD_ALERT', { id, ...change.doc.data() })
      //         }
      //       })
      //       commit('updateLoading', false)
      //     }, e => console.log(e))
      // } else {
      //   this.$db.collection('tenants')
      //     .doc(getters.getSessionTenant)
      //     .collection('alerts')
      //     .where('uid', '==', get(firebase.auth(), 'currentUser.uid'))
      //     .limit(state.alertPageLimit)
      //     .orderBy('createdAt', 'desc')
      //     .onSnapshot(snap => {
      //       if (snap.docs.length === state.alertPageLimit) {
      //         console.log('got ', snap.docs)
      //         commit('SET_LAST_ALERT', snap.docs[ snap.docs.length - 1 ])
      //       } else {
      //         commit('SET_LAST_ALERT', null)
      //       }
      //
      //       snap.docChanges().forEach(change => {
      //         console.log(change.doc.data())
      //
      //         if (change.type === 'added') {
      //           const source = change.doc.metadata.hasPendingWrites ? 'Local' : 'Server'
      //
      //           if (source === 'Server') {
      //             const { id } = change.doc
      //             commit('ADD_ALERT', { id, ...change.doc.data() })
      //           }
      //         }
      //
      //         if (change.type === 'removed') {
      //           //console.log('probably dont want to remove the unread alerts')
      //           //commit('REMOVE_ALERT', change.doc.id)
      //         }
      //
      //         if (change.type === 'modified') {
      //           const { id } = change.doc
      //           commit('ADD_ALERT', { id, ...change.doc.data() })
      //         }
      //       })
      //       commit('updateLoading', false)
      //     }, e => console.log(e))
      // }


    },
    initUnreadAlerts({ commit, getters }) {
      if (!getters.getSessionTenant) {
        return
      }
      // can we get the uid from teh store from a module store?
      // then we do not have to import firebase auth
      this.$db.collection('tenants')
        .doc(getters.getSessionTenant)
        .collection('alerts')
        .where('uid', '==', get(firebase.auth(), 'currentUser.uid'))
        .where('isRead', '==', false)
        .orderBy('createdAt', 'desc')
        .limit(10)
        .onSnapshot(snap => {
          snap.docChanges().forEach(change => {

            if (change.type === 'added') {
              const source = change.doc.metadata.hasPendingWrites ? 'Local' : 'Server'

              if (source === 'Server') {
                const { id } = change.doc
                commit('ADD_ALERT', { id, ...change.doc.data() })
              }
            }

            if (change.type === 'removed') {
              // If an alert is removed from this listener, it means that it was marked as read
              // We simulate the alert being removed by adding it with the updated value
              const { id } = change.doc
              commit('ADD_ALERT', {
                id,
                ...change.doc.data(),
                isRead: true
              })
            }

            if (change.type === 'modified') {
              const { id } = change.doc
              commit('ADD_ALERT', { id, ...change.doc.data() })
            }
          })
        }, e => console.log(e))
    },
    markAsRead({ state, commit, getters }, id) {

      const merge = true
      const payload = {
        isRead: true
      }

      this.$db.collection('tenants')
        .doc(getters.getSessionTenant)
        .collection('alerts')
        .doc(id)
        .set(payload, { merge })
        .catch(e => console.log(e))
    },
    markAllAsRead({ state, commit, getters }) {
      const payload = { isRead: true }
      const merge = true
      const batch = this.$db.batch()

      const unreadAlertIds = getters.getUnreadAlerts.map(a => a.id)

      unreadAlertIds.forEach(id => {
        const ref = this.$db.collection('tenants')
          .doc(getters.getSessionTenant)
          .collection('alerts')
          .doc(id)
        batch.set(ref, payload, { merge })
      })

      try {
        batch.commit().then((stuff) => console.log('done', stuff))
      } catch (e) {
        console.log(e)
      }
    }
  },
  mutations: {
    SET_LAST_ALERT(state, doc) {
      state.lastAlert = doc
    },
    ADD_ALERT(state, alert) {
      const { id } = alert

      if (id) {
        const newState = { ...state.alerts }
        newState[ id ] = alert
        state.alerts = newState
      }
    },
    REMOVE_ALERT(state, id) {
      if (state.alerts[ id ]) {
        const newState = { ...state.alerts }
        delete newState[ id ]
        state.alerts = newState
      }
    }
  },
}
